import { render } from "./Realtor.vue?vue&type=template&id=0ace34bf&scoped=true"
import script from "./Realtor.vue?vue&type=script&lang=js"
export * from "./Realtor.vue?vue&type=script&lang=js"

import "./Realtor.vue?vue&type=style&index=0&id=0ace34bf&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ace34bf"]])

export default __exports__